import { render, staticRenderFns } from "./accept-position.vue?vue&type=template&id=2736b126&"
import script from "./accept-position.vue?vue&type=script&lang=js&"
export * from "./accept-position.vue?vue&type=script&lang=js&"
import style0 from "./accept-position.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "accept-position.vue"
export default component.exports